'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product10__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.mo;
      break;
    }
    case 1: {
      return $thiz.mq;
      break;
    }
    case 2: {
      return $thiz.mr;
      break;
    }
    case 3: {
      return $thiz.ms;
      break;
    }
    case 4: {
      return $thiz.mt;
      break;
    }
    case 5: {
      return $thiz.mu;
      break;
    }
    case 6: {
      return $thiz.mv;
      break;
    }
    case 7: {
      return $thiz.mw;
      break;
    }
    case 8: {
      return $thiz.mx;
      break;
    }
    case 9: {
      return $thiz.mp;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 9)"));
    }
  }
}
export { $f_s_Product10__productElement__I__O as $f_s_Product10__productElement__I__O };
